import usePOST from 'rest/usePOST';

import { FINTECH_PATHS } from 'rest/const';


export default function useCardsTableButtonsHandler(
           setAlert, axiosCfg, //Common props
           rowWithCardToActivate, setRowWithCardToActivate, //Card activation props
           topUpCardBody, setTopUpCardBody, //Card top upping props
) {

  /**
   * Card activation
   */

  const activateCardPath = rowWithCardToActivate
    ? FINTECH_PATHS.activateCard.replace('{cardId}', rowWithCardToActivate.original.cardId)
    : null; //null path means 'don't send POST'
  usePOST(activateCardPath, {}, axiosCfg, {
    onSuccess: () => {
      //Change the status visually without refetching whole table, for whatever reason it requires changing 2 values lol
      rowWithCardToActivate.original.status = 'ACTIVE'; //Will update value in the tableData too, as a result button will dissapear on rerender
      rowWithCardToActivate._valuesCache.status = 'ACTIVE'; //Will update value displayed in the table on rerender
      //Prevent it from sending another POST
      setRowWithCardToActivate(null);
      setAlert({
        msgTranslKey: 'success',
        type:         'success',
      });
    },
    onError: () => {
      //Prevent it from sending another POST
      setRowWithCardToActivate(null);
      setAlert({
        msgTranslKey:          'serverError',
        msgTranslSecondaryKey: 'activateCardError',
        type:                  'error',
      });
    },
  });

  /**
   * Card top upping
   */

  const topUpPath = topUpCardBody ? FINTECH_PATHS.topUpCard : null; //null path means 'don't send POST'
  usePOST(topUpPath, topUpCardBody, axiosCfg, {
    //Prevent it from sending another POST
    onSuccess: () => {
      setTopUpCardBody(null);
      setAlert({
        msgTranslKey: 'success',
        type:         'success',
      });
    },
    onError: () => {
      //Prevent it from sending another POST
      setTopUpCardBody(null);
      setAlert({
        msgTranslKey:          'serverError',
        msgTranslSecondaryKey: 'topUpCardError',
        type:                  'error',
      });
    },
  });

}
